/** Growable typed-array builders - surfaces routinely carry millions of vertices. */

export class F64Buf {
  private a: Float64Array;
  private n = 0;
  constructor(cap = 1024) { this.a = new Float64Array(Math.max(1, cap)); }
  get length(): number { return this.n; }
  push3(x: number, y: number, z: number): void {
    if (this.n + 3 > this.a.length) this.grow(this.n + 3);
    this.a[this.n++] = x; this.a[this.n++] = y; this.a[this.n++] = z;
  }
  push(v: number): void {
    if (this.n + 1 > this.a.length) this.grow(this.n + 1);
    this.a[this.n++] = v;
  }
  at(i: number): number { return this.a[i]; }
  private grow(min: number): void {
    let cap = this.a.length * 2;
    while (cap < min) cap *= 2;
    const b = new Float64Array(cap);
    b.set(this.a.subarray(0, this.n));
    this.a = b;
  }
  toArray(): Float64Array { return this.a.slice(0, this.n); }
}

export class U32Buf {
  private a: Uint32Array;
  private n = 0;
  constructor(cap = 1024) { this.a = new Uint32Array(Math.max(1, cap)); }
  get length(): number { return this.n; }
  push3(a: number, b: number, c: number): void {
    if (this.n + 3 > this.a.length) this.grow(this.n + 3);
    this.a[this.n++] = a; this.a[this.n++] = b; this.a[this.n++] = c;
  }
  private grow(min: number): void {
    let cap = this.a.length * 2;
    while (cap < min) cap *= 2;
    const b = new Uint32Array(cap);
    b.set(this.a.subarray(0, this.n));
    this.a = b;
  }
  toArray(): Uint32Array { return this.a.slice(0, this.n); }
}

export class U8Buf {
  private a: Uint8Array;
  private n = 0;
  constructor(cap = 1024) { this.a = new Uint8Array(Math.max(1, cap)); }
  get length(): number { return this.n; }
  push(v: number): void {
    if (this.n + 1 > this.a.length) {
      let cap = this.a.length * 2;
      while (cap < this.n + 1) cap *= 2;
      const b = new Uint8Array(cap);
      b.set(this.a.subarray(0, this.n));
      this.a = b;
    }
    this.a[this.n++] = v;
  }
  toArray(): Uint8Array { return this.a.slice(0, this.n); }
}
